export default {
    // 公共
    hello:"Hello~",
    welcome: "Welcome to the Plus18 Games Customer Service Center",
    connecting: "Your dedicated customer service representative is connecting...",
    waitting: "Please wait a moment",
    email:"Customer Service Email",

}